import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLottie } from 'lottie-react';
import checkAnimation from '../../assets/Animations/Success-300x300.json';
import { redirect } from '../../utils/redirect';
import AppStateContext from '../../AppStateProvider/context';
import { complete } from '../../utils/complete';
import { encodeString } from '../../utils/encoding';


export default function Final() {
	const { t, i18n } = useTranslation();
	const { state } = useContext(AppStateContext);
	const completeState = complete(state);
	const { View } = useLottie({
		animationData: checkAnimation,
		loop: false,
		className: 'animation',
		onComplete: () => {
			if (completeState) redirect(state.brand);
		},
	});

	if (!completeState) {
		return (
			<div className='top'>
				<div className='final'>
					<h1>{t('FinalErrorHeadline')}</h1>
					<p className='p1'>{t('FinalErrorText')}</p>
				</div>
			</div>
		);
	}

	const setupToStore = {
		brand: state.brand,
		market: state.market,
		kvps: state.kvps,
		password: encodeString(state.password),
		userPassword: encodeString(state.userPassword),
		device: state.device,
		language: i18n.language,
		label: state.goToLabel,
		chromeboxLabel: state.chromeboxLabel,
		pinpairingActivationResponse: state.pinpairingActivationResponse,
		clientId: `${state.market?.urls?.delivery ||state.market?.qsUrl || 'unknown'}_${state.device || 'device'}`,
		show_second_screen: state.show_second_screen,
		orientation: state.orientation,
		pairing: state.pairing
	};

	try {
		localStorage.setItem('setup', JSON.stringify(setupToStore));
	} catch (e) {

		console.error('[Final] Error while writing setup in LS', e);
	}

	return (
		<div className='top'>
			<div className='final'>
				{!state.preview && (
					<>
						<h1>{t('FinalHeadline')}</h1>
						<p className='p1'>{t('FinalText')}</p>
					</>
				)}
				<>{View}</>
			</div>
		</div>
	);
}
